import { takeLatest, put, call } from 'redux-saga/effects'
import * as actions from '../slices/index'

import LandingPage from '../../api/landingPage'
import constants from '../../constants'

// Worker Saga: Get GoodFlip Insights
function* getSemaLandingPageSaga(action) {
  try {
    const response = yield call(LandingPage.getSemaLandingPage, action.payload)

    if (response?.code == 1) {
      yield put(actions.fetchSemaLandingPageSuccess(response?.data))
    } else {
      yield put(
        actions.fetchSemaLandingPageError(
          response?.message || constants.ERROR_MSG,
        ),
      )
    }
  } catch (error) {
    yield put(
      actions.fetchSemaLandingPageError(error?.message || constants.ERROR_MSG),
    )
  }
}

export function* landingPageSaga() {
  yield takeLatest(actions.fetchSemaLandingPageRequest, getSemaLandingPageSaga)
}
